import { BlogPost } from "./types";
import { getBlogImageUrl, getCollectionImageUrl } from "@/lib/cloudinary";

export const blogPosts: BlogPost[] = [
  {
    id: 1,
    titre: "LA COLORATION DES CHEVEUX",
    sousTitre: "Maîtriser l'art des nuances",
    paragraph:
      "La coloration capillaire est bien plus qu'un simple changement de teinte, c'est un outil puissant pour révéler la personnalité et sublimer un style. Du balayage subtil aux transformations complètes, chaque technique demande une maîtrise parfaite des produits et une attention aux détails. Explorez les astuces pour préserver la santé des cheveux tout en garantissant une tenue durable de la couleur. Apprenez également comment adapter les nuances aux teints et aux tendances actuelles pour un résultat harmonieux. Conseil : Utilisez des soins spécifiques post-coloration pour prolonger l'intensité et la brillance.",
    images: [getBlogImageUrl("coloration-des-cheveux")],
    createdAt: "2024-12-04T22:23:29.173Z",
    updatedAt: "2024-12-04T22:23:29.173Z",
    labels: ["produits"],
  },
  {
    id: 2,
    titre: "L'ENTRETIEN DES CHEVEUX",
    sousTitre: "Des outils et soins adaptés",
    paragraph:
      "Pour des cheveux éclatants et en pleine santé, il est essentiel de combiner les bons outils avec des soins adaptés. Le choix du fer à lisser, du peigne et des produits capillaires joue un rôle clé dans la routine quotidienne. Apprenez à éviter les dommages liés à la chaleur en utilisant des protections thermiques et privilégiez des soins nourrissants pour réparer les fibres capillaires. Découvrez également des astuces pour un démêlage en douceur et une coiffure sans frisottis. Conseil : Alternez entre des soins hydratants et réparateurs pour des cheveux équilibrés et résistants.",
    images: [getBlogImageUrl("entretien-cheveux")],
    createdAt: "2024-12-01T22:23:29.173Z",
    updatedAt: "2024-12-01T22:23:29.173Z",
    labels: ["bien-etre"],
  },
  {
    id: 3,
    titre: "LE CHOIX DES PRODUITS CAPILLAIRES",
    sousTitre: "Une sélection qui fait la différence",
    paragraph:
      "Chaque cheveu a des besoins spécifiques, et le choix des produits capillaires est crucial pour répondre à ces exigences. Des colorations adaptées aux shampoings professionnels, en passant par les soins spécifiques, la sélection d'une gamme de qualité garantit des résultats durables et respectueux de la fibre capillaire. Découvrez les critères pour choisir les meilleurs produits en fonction des types de cheveux et des objectifs souhaités. Conseil : Stockez vos produits dans un endroit sec et vérifiez régulièrement les dates de péremption pour préserver leur efficacité.",
    images: [getBlogImageUrl("produits-cheveux")],
    createdAt: "2024-11-25T22:23:29.173Z",
    updatedAt: "2024-11-25T22:23:29.173Z",
    labels: ["produits"],
  },
  {
    id: 4,
    titre: "LE LAVAGE PROFESSIONNEL",
    sousTitre: "La base d'un soin parfait",
    paragraph:
      "Un bon lavage capillaire est l'étape fondamentale pour des cheveux éclatants et en bonne santé. En salon, le choix du shampoing, adapté au type de cheveux, et la technique de massage jouent un rôle clé pour nettoyer en profondeur tout en stimulant le cuir chevelu. Découvrez les bénéfices d'un double lavage et l'importance de rincer abondamment pour éviter les résidus. Conseil : Terminez toujours par un rinçage à l'eau tiède pour refermer les écailles et garantir une brillance optimale.",
    images: [getBlogImageUrl("lavage-professionnel")],
    createdAt: "2024-11-08T22:23:29.173Z",
    updatedAt: "2024-11-08T22:23:29.173Z",
    labels: ["bien-etre"],
  },
  {
    id: 5,
    titre: "LES CISEAUX DE COIFFURE",
    sousTitre: "L'outil signature du professionnel",
    paragraph:
      "Les ciseaux de coiffure ne sont pas de simples outils, ils sont l'extension de la main du coiffeur. Le choix de la taille, du type de lame (droite ou dentelée), et de l'ergonomie est essentiel pour garantir confort et précision. Découvrez comment bien entretenir vos ciseaux avec des techniques simples pour prolonger leur durabilité, comme l'affûtage régulier et le nettoyage après chaque utilisation. Conseil : Rangez toujours vos ciseaux dans une housse adaptée pour éviter les dommages et préserver leur qualité de coupe.",
    images: [getBlogImageUrl("ciseaux-en-coiffure")],
    createdAt: "2024-10-25T22:23:29.173Z",
    updatedAt: "2024-10-25T22:23:29.173Z",
    labels: ["soins"],
  },
  {
    id: 6,
    titre: "LA COIFFURE ARTISTIQUE",
    sousTitre: "Exprimer sa créativité",
    paragraph:
      "La coiffure est bien plus qu'une technique, c'est un art qui sublime la personnalité. Des jeux de textures aux effets lumineux, chaque détail peut transformer une coiffure en œuvre unique. Découvrez comment adapter les styles aux événements ou aux envies de vos clients tout en jouant avec les couleurs, les volumes et les accessoires. Conseil : Utilisez des éclairages spécifiques pour mettre en valeur les nuances et le mouvement de la coiffure, offrant ainsi une expérience visuelle inoubliable.",
    images: [getBlogImageUrl("coiffure-artistique")],
    createdAt: "2024-10-08T22:23:29.173Z",
    updatedAt: "2024-10-08T22:23:29.173Z",
    labels: ["style"],
  },
  {
    id: 7,
    titre: "SUBLIMER LES CHEVEUX BOUCLÉS",
    sousTitre: "Valoriser la texture naturelle",
    paragraph:
      "Les cheveux bouclés demandent une attention particulière pour révéler toute leur beauté et leur éclat. L'utilisation de produits hydratants et de techniques adaptées, comme le scrunching ou le séchage à l'air libre, permet de définir les boucles tout en évitant les frisottis. Découvrez comment choisir les soins qui nourrissent en profondeur et maintiennent une hydratation optimale. Conseil : Utilisez un diffuseur pour sécher délicatement et donner du volume sans casser les boucles.",
    images: [getBlogImageUrl("sublimer-les-cheveux-boucles")],
    createdAt: "2024-09-11T22:23:29.173Z",
    updatedAt: "2024-09-11T22:23:29.173Z",
    labels: ["soins"],
  },
  {
    id: 8,
    titre: "LE BIEN-ÊTRE EN SALON",
    sousTitre: "Une expérience relaxante pour tous",
    paragraph:
      "Se rendre chez le coiffeur ne se limite plus à une simple coupe ou un soin, c'est un véritable moment de détente. Offrir un cadre chaleureux, un service personnalisé et même des attentions spéciales comme l'accueil des animaux permet de transformer une visite en une expérience mémorable. Découvrez comment instaurer un environnement où chaque client se sent unique et choyé. Conseil : Ajoutez des touches de convivialité, comme une boisson chaude ou une playlist relaxante, pour renforcer le bien-être global.",
    images: [getBlogImageUrl("bien-etre-en-salon")],
    createdAt: "2024-09-01T22:23:29.173Z",
    updatedAt: "2024-09-01T22:23:29.173Z",
    labels: ["bien-etre"],
  },
  {
    id: 9,
    titre: "LE STYLE MASCULIN PARFAIT",
    sousTitre: "Une coupe qui fait la différence",
    paragraph:
      "Une coiffure soignée et adaptée est essentielle pour affirmer son style et sa confiance. Que ce soit une coupe classique ou moderne, le choix d'une bonne structure et d'une finition nette permet de valoriser les traits du visage. Découvrez les astuces pour entretenir une coiffure masculine impeccable, en misant sur des produits adaptés comme les cires ou gels coiffants. Conseil : Prenez rendez-vous régulièrement pour ajuster la coupe et gardez une barbe bien définie pour un look harmonieux.",
    images: [getBlogImageUrl("style-masculin-parfait")],
    createdAt: "2024-08-15T22:23:29.173Z",
    updatedAt: "2024-08-15T22:23:29.173Z",
    labels: ["style"],
  },
  {
    id: 10,
    titre: "LES CHEVEUX LONGS ONDULÉS",
    sousTitre: "Sublimer le volume naturel",
    paragraph:
      "Les cheveux longs et ondulés sont synonymes d'élégance et de mouvement. Pour entretenir cette texture et mettre en valeur chaque mèche, il est essentiel d'utiliser des soins adaptés à l'hydratation et au maintien des ondulations. Découvrez des astuces pour un coiffage léger, avec des produits comme les sprays texturisants ou les crèmes coiffantes. Conseil : Brossez vos cheveux avec les doigts ou un peigne à dents larges pour préserver les ondulations naturelles et éviter les frisottis.",
    images: [getBlogImageUrl("cheveux-longs-ondules")],
    createdAt: "2024-08-02T22:23:29.173Z",
    updatedAt: "2024-08-02T22:23:29.173Z",
    labels: ["soins"],
  },
  {
    id: 11,
    titre: "L'ART DE LA COUPE",
    sousTitre: "Précision et savoir-faire",
    paragraph:
      "Une coupe réussie repose sur une technique irréprochable et des outils de qualité. Que ce soit pour rafraîchir une longueur ou créer un tout nouveau style, chaque geste doit être précis et adapté à la nature du cheveu. Découvrez les meilleures pratiques pour personnaliser chaque coupe en fonction des attentes et des traits du visage des clients. Conseil : Affûtez régulièrement vos ciseaux pour garantir une coupe nette et éviter d'abîmer les pointes.",
    images: [getBlogImageUrl("art-de-la-coupe")],
    createdAt: "2024-07-16T22:23:29.173Z",
    updatedAt: "2024-07-16T22:23:29.173Z",
    labels: ["soins"],
  },
  {
    id: 12,
    titre: "L'IMPORTANCE DES SOINS DU VISAGE",
    sousTitre: "Une peau éclatante au quotidien",
    paragraph:
      "Prendre soin de son visage est essentiel pour une peau lumineuse et en bonne santé. Une routine adaptée, comprenant un nettoyage doux, une hydratation quotidienne et des soins ciblés, aide à préserver l'élasticité et la fraîcheur de la peau. Découvrez les gestes simples pour nourrir votre épiderme tout en protégeant votre barrière cutanée. Conseil : Appliquez toujours votre crème hydratante sur une peau légèrement humide pour maximiser l'absorption et les bienfaits.",
    images: [getBlogImageUrl("importance-soin-visage")],
    createdAt: "2024-07-05T22:23:29.173Z",
    updatedAt: "2024-07-05T22:23:29.173Z",
    labels: ["bien-etre"],
  },
  {
    id: 13,
    titre: "LE STYLE WAVY PARFAIT",
    sousTitre: "Naturel et élégant",
    paragraph:
      "Le style wavy est l'une des tendances incontournables pour un look à la fois sophistiqué et décontracté. Ce type de coiffure met en valeur le mouvement naturel des cheveux tout en apportant du volume et de la légèreté. Pour un résultat impeccable, utilisez un fer à boucler ou une technique de tressage avant de dormir pour créer des ondulations sans chaleur. Conseil : Appliquez un spray texturisant pour fixer les vagues et donner un effet coiffé-décoiffé longue durée.",
    images: [getBlogImageUrl("style-wavy-parfait")],
    createdAt: "2024-06-16T22:23:29.173Z",
    updatedAt: "2024-06-16T22:23:29.173Z",
    labels: ["style"],
  },
  {
    id: 14,
    titre: "LA COIFFURE CHIC ET AUDACIEUSE",
    sousTitre: "Quand style et élégance se rencontrent",
    paragraph:
      "Une coiffure courte et bien structurée peut transformer un look, en ajoutant une touche moderne et audacieuse. Accessoiriser avec un chapeau ou un bandeau est une excellente manière de rehausser le style tout en mettant en valeur les traits du visage. Découvrez les astuces pour entretenir une coupe courte et conserver son éclat, notamment grâce à des soins hydratants et des finitions parfaites. Conseil : Appliquez une cire légère pour sculpter les mèches et ajouter de la brillance sans alourdir.",
    images: [getBlogImageUrl("coiffure-chic-et-audacieuse")],
    createdAt: "2024-06-10T22:23:29.173Z",
    updatedAt: "2024-06-10T22:23:29.173Z",
    labels: ["style"],
  },
  {
    id: 15,
    titre: "LA COIFFURE DE MARIÉE PAR EXCELLENCE",
    sousTitre: "Élégance et romantisme pour le grand jour",
    paragraph:
      "La coiffure de mariée est une œuvre d'art qui doit allier raffinement et tenue parfaite pour sublimer ce jour unique. Du chignon sophistiqué aux ondulations naturelles, chaque détail doit être pensé en harmonie avec la robe et les accessoires. Découvrez les techniques pour une coiffure qui résiste toute la journée, avec des produits fixants légers et un soin particulier apporté aux finitions. Conseil : Faites un essai coiffure avant le jour J pour ajuster chaque détail et garantir un résultat parfait.",
    images: [getBlogImageUrl("coiffure-mariee-par-excellence")],
    createdAt: "2024-05-21T22:23:29.173Z",
    updatedAt: "2024-05-21T22:23:29.173Z",
    labels: ["style"],
  },
  {
    id: 16,
    titre: "LA BEAUTÉ DES SOURCILS",
    sousTitre: "Structurer le regard avec précision",
    paragraph:
      "Les sourcils bien définis sont essentiels pour encadrer le visage et intensifier le regard. Un entretien régulier, associé à des techniques adaptées comme l'épilation ou le maquillage, permet de sublimer leur forme naturelle. Découvrez les meilleures astuces pour dessiner des sourcils harmonieux en tenant compte de la morphologie du visage. Conseil : Utilisez un crayon ou une poudre de teinte proche de votre couleur naturelle pour un rendu subtil et élégant.",
    images: [getBlogImageUrl("beaute-sourcils")],
    createdAt: "2024-05-17T22:23:29.173Z",
    updatedAt: "2024-05-17T22:23:29.173Z",
    labels: ["soins"],
  },
  {
    id: 17,
    titre: "LE SHAMPOING SOLIDE",
    sousTitre: "Prenez soin de vos cheveux et de la planète",
    paragraph:
      "Le shampoing solide est une alternative innovante et écologique aux produits liquides traditionnels. Enrichi en ingrédients naturels, il nettoie en profondeur tout en respectant le cuir chevelu et l'environnement. Pratique, il offre une mousse généreuse et se transporte facilement. Découvrez les bienfaits de ce produit durable et comment l'intégrer à votre routine capillaire. Conseil : Laissez sécher votre shampoing solide après chaque utilisation pour prolonger sa durée de vie.",
    images: [getBlogImageUrl("shampoing-solide")],
    createdAt: "2024-04-15T22:23:29.173Z",
    updatedAt: "2024-04-15T22:23:29.173Z",
    labels: ["produits"],
  },
  {
    id: 18,
    titre: "PRENDRE SOIN DE SES BOUCLES",
    sousTitre: "Révélez leur éclat naturel",
    paragraph:
      "Les cheveux bouclés nécessitent des soins spécifiques pour rester hydratés et bien définis. Une routine adaptée, comprenant un shampoing doux et un soin hydratant sans rinçage, permet de sublimer les boucles tout en évitant les frisottis. Découvrez les gestes essentiels pour entretenir vos boucles et préserver leur beauté au quotidien. Conseil : Évitez les peignes fins, privilégiez vos doigts ou un peigne à dents larges pour démêler sans casser les boucles.",
    images: [getBlogImageUrl("prendre-soin-boucles")],
    createdAt: "2024-04-10T22:23:29.173Z",
    updatedAt: "2024-04-10T22:23:29.173Z",
    labels: ["soins"],
  },
  {
    id: 19,
    titre: "LE PEIGNE, UN OUTIL ESSENTIEL",
    sousTitre: "Techniques et astuces pour un démêlage parfait",
    paragraph:
      "Le choix et l'utilisation du peigne sont cruciaux pour préserver la santé des cheveux. Un peigne à dents larges est idéal pour démêler les cheveux sans les casser, surtout lorsqu'ils sont mouillés. Adoptez des gestes doux, en commençant par les pointes avant de remonter vers les racines, pour éviter les nœuds et les tiraillements. Conseil pro : Nettoyez régulièrement vos outils pour éliminer les résidus de produits et prolonger leur efficacité.",
    images: [getBlogImageUrl("peigne-outil-essentiel")],
    createdAt: "2024-03-27T22:23:29.173Z",
    updatedAt: "2024-03-27T22:23:29.173Z",
    labels: ["conseils"],
  },
  {
    id: 20,
    titre: "COUPE PEIGNE-TONDEUSE",
    sousTitre: "La précision avant tout",
    paragraph:
      "La technique du peigne et de la tondeuse est incontournable pour des coupes masculines nettes et structurées. Elle permet de maîtriser les dégradés avec précision et d'adapter la coupe à chaque morphologie. Découvrez les gestes essentiels pour un travail professionnel, notamment l'importance de maintenir un angle constant entre le peigne et la tondeuse. Conseil : Vérifiez régulièrement la lame de votre tondeuse pour garantir une coupe fluide et éviter les accrocs.",
    images: [getBlogImageUrl("coupe-peigne-tondeuse")],
    createdAt: "2024-03-14T22:23:29.173Z",
    updatedAt: "2024-03-14T22:23:29.173Z",
    labels: ["conseils"],
  },
  {
    id: 21,
    titre: "LA PRÉPARATION DE LA COLORATION",
    sousTitre: "Précision et maîtrise pour un résultat parfait",
    paragraph:
      "La préparation d'une coloration capillaire demande rigueur et savoir-faire. Chaque étape, du mélange des produits à l'application, est cruciale pour obtenir un résultat uniforme et éclatant. Assurez-vous de respecter les dosages et d'utiliser des outils adaptés, comme un pinceau et un bol de qualité professionnelle. Conseil : Portez toujours des gants pour protéger vos mains et garantir une hygiène irréprochable.",
    images: [getBlogImageUrl("preparation-coloration")],
    createdAt: "2024-02-10T22:23:29.173Z",
    updatedAt: "2024-02-10T22:23:29.173Z",
    labels: ["soins"],
  },
  {
    id: 22,
    titre: "L'ACCUEIL EN SALON",
    sousTitre: "Créer une expérience unique",
    paragraph:
      "L'accueil est une étape essentielle pour fidéliser vos clients et leur offrir une expérience mémorable. Une attention particulière dès leur arrivée, accompagnée d'un sourire chaleureux et d'une écoute attentive, permet de créer un lien de confiance. Découvrez les meilleures pratiques pour un accueil irréprochable, comme proposer une boisson ou discuter des attentes avant de commencer la prestation. Conseil : Adaptez votre approche à chaque client pour qu'il se sente valorisé et unique.",
    images: [getBlogImageUrl("accueil-en-salon")],
    createdAt: "2024-02-09T22:23:29.173Z",
    updatedAt: "2024-02-09T22:23:29.173Z",
    labels: ["bien-etre"],
  },
  {
    id: 23,
    titre: "LA POSE D'EXTENSIONS BOUCLÉES",
    sousTitre: "Volume et longueur en toute élégance",
    paragraph:
      "Les extensions bouclées permettent d'ajouter volume et longueur tout en sublimant les coiffures. La clé d'une pose réussie réside dans une préparation minutieuse et une intégration harmonieuse avec les cheveux naturels. Adoptez des techniques professionnelles pour un rendu naturel et durable. Conseil : Séparez les cheveux en sections fines pour une fixation précise et appliquez un soin nourrissant après la pose pour préserver la qualité des boucles.",
    images: [getBlogImageUrl("pose-extensions-bouclees")],
    createdAt: "2024-01-20T22:23:29.173Z",
    updatedAt: "2024-01-20T22:23:29.173Z",
    labels: ["soins"],
  },
  {
    id: 24,
    titre: "LE MASSAGE CAPILLAIRE",
    sousTitre: "L'allié de votre bien-être",
    paragraph:
      "Un massage capillaire ne se limite pas à un moment de détente ; il stimule également la circulation sanguine du cuir chevelu, favorise la pousse des cheveux et aide à éliminer les impuretés. Utilisez des mouvements circulaires doux et des huiles essentielles adaptées pour maximiser les bienfaits. En plus de renforcer la fibre capillaire, ce rituel offre une expérience apaisante pour l'esprit et le corps. Astuce : intégrez ce geste lors de chaque lavage pour transformer une routine basique en soin complet.",
    images: [getBlogImageUrl("massage-capillaire-secret-sante")],
    createdAt: "2024-01-14T22:23:29.173Z",
    updatedAt: "2024-01-14T22:23:29.173Z",
    labels: ["bien-etre"],
  },
  {
    id: 25,
    titre: "VOS ESSENTIELS CAPILLAIRES",
    sousTitre: "Des outils simples pour des cheveux sublimes",
    paragraph:
      "Pour des cheveux éclatants de santé, misez sur des essentiels de qualité. Un shampooing adapté à votre type de cuir chevelu, un après-shampoing nourrissant, et un peigne à dents larges pour démêler sans abîmer la fibre capillaire. Complétez votre routine avec un soin hebdomadaire pour hydrater en profondeur. Astuce : lisez les étiquettes pour éviter les produits contenant des sulfates ou des silicones qui fragilisent vos cheveux sur le long terme.",
    images: [getBlogImageUrl("essentiels-capillaires")],
    createdAt: "2023-12-27T22:23:29.173Z",
    updatedAt: "2023-12-27T22:23:29.173Z",
    labels: ["conseils"],
  },
  {
    id: 26,
    titre: "LA MAÎTRISE DU COUP DE CISEAU",
    sousTitre: "Technique et Précision",
    paragraph:
      "Dans l'art de la coiffure, chaque coupe raconte une histoire, et cette histoire commence avec la maîtrise des ciseaux. Un bon coiffeur sait que la précision est essentielle : de la posture des mains au contrôle des mèches, chaque geste est calculé pour un résultat harmonieux. L'équilibre entre technique et créativité fait toute la différence. Découvrez des astuces pour améliorer votre précision et les méthodes pour des finitions parfaites. Nous mettons également en lumière les outils qui permettent d'atteindre une maîtrise optimale, tout en préservant le confort de vos clients. Conseil : Tenez vos ciseaux légèrement inclinés pour plus de fluidité dans vos mouvements et évitez les tensions musculaires.",
    images: [getBlogImageUrl("maitrise-coup-de-ciseau")],
    createdAt: "2023-12-25T22:23:29.173Z",
    updatedAt: "2023-12-25T22:23:29.173Z",
    labels: ["soins", "conseils"],
  },
  {
    id: 27,
    titre: "LE LOOK ÉLÉGANCE NATURELLE",
    sousTitre: "Style & Charisme",
    paragraph:
      "Un style impeccable passe par une coiffure qui respire la simplicité et la sophistication. Ici, les longueurs lisses et brillantes révèlent un look naturel et intemporel, parfait pour une allure chic au quotidien. Que ce soit pour un rendez-vous professionnel ou une sortie décontractée, ce style s'adapte à toutes les occasions. Découvrez les astuces pour maintenir des cheveux soyeux et brillants, ainsi que les produits incontournables pour un fini éclatant. Conseil : Utilisez un sérum nourrissant après le lissage pour protéger vos longueurs et conserver cet effet miroir durablement.",
    images: [getBlogImageUrl("look-elegance-naturelle")],
    createdAt: "2023-11-17T22:23:29.173Z",
    updatedAt: "2023-11-17T22:23:29.173Z",
    labels: ["bien-etre", "style"],
  },
  {
    id: 28,
    titre: "LE SECRET DU MASQUE PURIFIANT",
    sousTitre: "Bien-être et Éclat",
    paragraph:
      "Prendre soin de sa peau, c'est s'accorder un moment pour soi. Le masque purifiant est l'allié parfait pour nettoyer en profondeur, éliminer les impuretés et redonner de l'éclat à votre visage. Composé d'argile ou de charbon actif, il agit en douceur tout en offrant une sensation de fraîcheur et de légèreté. Un rituel simple, mais essentiel pour une peau lumineuse et un bien-être intérieur. Conseil : Appliquez le masque sur une peau propre et sèche, laissez poser 10 à 15 minutes, puis rincez à l'eau tiède pour un résultat optimal.",
    images: [getBlogImageUrl("masque-purifiant")],
    createdAt: "2023-11-01T22:23:29.173Z",
    updatedAt: "2023-11-01T22:23:29.173Z",
    labels: ["bien-etre", "produits"],
  },
  {
    id: 29,
    titre: "LA BARBE : ENTRE STYLE ET ENTRETIEN",
    sousTitre: "Sublimez votre look avec une barbe soignée",
    paragraph:
      "La barbe n'est pas seulement une tendance, c'est un art. Pour un look impeccable, l'entretien est essentiel. Commencez par une coupe adaptée à la forme de votre visage. Nettoyez votre barbe régulièrement avec un shampooing spécifique pour éviter les irritations. Hydratez avec une huile pour barbe pour un toucher doux et une brillance naturelle. Enfin, peignez-la pour éviter les nœuds et maintenir une apparence ordonnée. Un professionnel peut vous guider pour un style unique qui reflète votre personnalité.",
    images: [getBlogImageUrl("tailler-barbe")],
    createdAt: "2025-01-07T22:23:29.173Z",
    updatedAt: "2025-01-07T22:23:29.173Z",
    labels: ["style"],
  },
  {
    id: 30,
    titre: "UNE PAUSE BEAUTÉ, UNE BULLE DE DOUCEUR",
    sousTitre: "Quand le bien-être rencontre la complicité",
    paragraph:
      "Prendre soin de soi ne devrait jamais être une simple routine. C'est un moment précieux, encore plus lorsqu'il est partagé avec un compagnon à quatre pattes. Imaginez-vous allongé, les cheveux chouchoutés par des mains expertes, tandis qu'un regard rempli de tendresse vous rappelle de savourer l'instant. Dans cette ambiance cocooning, tout est pensé pour allier détente et bonheur. Parce que se sentir bien, c'est aussi s'entourer de ce qu'on aime.",
    images: [getBlogImageUrl("bien-etre-en-salon")],
    createdAt: "2025-01-22T03:10:43.165Z",
    updatedAt: "2025-01-22T03:10:43.165Z",
    labels: ["bien-etre"],
  },
  {
    id: 31,
    titre: "OFFREZ UN CADEAU UNIQUE",
    sousTitre: "Une attention élégante à partir de 50€.",
    paragraph:
      "Trouver le cadeau parfait n'a jamais été aussi simple avec les cartes cadeaux Alexandra Grey. Disponibles dès 50€, elles sont entièrement personnalisables et valables dans tous nos salons. Offrir une carte Alexandra Grey, c'est bien plus qu'un simple cadeau : c'est offrir un moment de bien-être, une expérience luxe et une coiffure réalisée par des experts.\n\nPeu importe l'occasion, notre équipe se fera un plaisir de transformer cette attention en un moment inoubliable.\n\nRendez-vous dans l'un de nos salons à Villejuif, Ville d'Avray, ou au concept salon Au Grey des Couleurs pour découvrir une vision unique et moderne de la coiffure.",
    images: [
      getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-01"),
    ],
    createdAt: "2025-01-22T03:29:06.202Z",
    updatedAt: "2025-01-22T03:29:06.202Z",
    labels: ["produits"],
  },
];
